import React from 'react';
import { useSelector } from 'react-redux';
import { PromoBlocks } from '../../components/PromoBlocks';
import { selectSuburbanPromoBlock } from '../../selectors/selectSuburbanPromoBlock';

export const PromoBlocksContainer = () => {
  const promoData = useSelector(selectSuburbanPromoBlock);

  return <PromoBlocks promo={promoData} />;
};
